"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultTransceiverController_1 = require("./DefaultTransceiverController");

var SimulcastTransceiverController = /*#__PURE__*/function (_DefaultTransceiverCo) {
  _inherits(SimulcastTransceiverController, _DefaultTransceiverCo);

  var _super = _createSuper(SimulcastTransceiverController);

  function SimulcastTransceiverController(logger, browserBehavior) {
    var _this;

    _classCallCheck(this, SimulcastTransceiverController);

    _this = _super.call(this, logger, browserBehavior);
    _this.videoQualityControlParameterMap = new Map();
    var scale = 4;

    for (var i = 0; i < SimulcastTransceiverController.NAME_ARR_ASCENDING.length; i++) {
      var ridName = SimulcastTransceiverController.NAME_ARR_ASCENDING[i];

      _this.videoQualityControlParameterMap.set(ridName, {
        rid: ridName,
        scaleResolutionDownBy: scale,
        maxBitrate: SimulcastTransceiverController.BITRATE_ARR_ASCENDING[i] * 1000
      });

      scale = scale / 2;
    }

    return _this;
  } // Note: `scaleResolutionDownBy` has only been tested with values 1, 2, and 4.


  _createClass(SimulcastTransceiverController, [{
    key: "setEncodingParameters",
    value: function setEncodingParameters(encodingParamMap) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var sender, newEncodingParams, oldParam, i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                sender = this._localCameraTransceiver.sender;
                newEncodingParams = Array.from(encodingParamMap.values());

                if (!(newEncodingParams.length <= 0)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                oldParam = sender.getParameters();

                if (!oldParam.encodings) {
                  oldParam.encodings = newEncodingParams;
                } else {
                  for (i = 0; i < oldParam.encodings.length; i++) {
                    if (oldParam.encodings[i].rid === SimulcastTransceiverController.LOW_LEVEL_NAME) {
                      oldParam.encodings[i].maxBitrate = encodingParamMap.get(SimulcastTransceiverController.LOW_LEVEL_NAME).maxBitrate;
                      oldParam.encodings[i].active = encodingParamMap.get(SimulcastTransceiverController.LOW_LEVEL_NAME).active;
                      oldParam.encodings[i].scaleResolutionDownBy = encodingParamMap.get(SimulcastTransceiverController.LOW_LEVEL_NAME).scaleResolutionDownBy;
                    }

                    if (oldParam.encodings[i].rid === SimulcastTransceiverController.MID_LEVEL_NAME) {
                      oldParam.encodings[i].maxBitrate = encodingParamMap.get(SimulcastTransceiverController.MID_LEVEL_NAME).maxBitrate;
                      oldParam.encodings[i].active = encodingParamMap.get(SimulcastTransceiverController.MID_LEVEL_NAME).active;
                      oldParam.encodings[i].scaleResolutionDownBy = encodingParamMap.get(SimulcastTransceiverController.MID_LEVEL_NAME).scaleResolutionDownBy;
                    }

                    if (oldParam.encodings[i].rid === SimulcastTransceiverController.HIGH_LEVEL_NAME) {
                      oldParam.encodings[i].maxBitrate = encodingParamMap.get(SimulcastTransceiverController.HIGH_LEVEL_NAME).maxBitrate;
                      oldParam.encodings[i].active = encodingParamMap.get(SimulcastTransceiverController.HIGH_LEVEL_NAME).active;
                      oldParam.encodings[i].scaleResolutionDownBy = encodingParamMap.get(SimulcastTransceiverController.HIGH_LEVEL_NAME).scaleResolutionDownBy;
                    }
                  }
                }

                _context.next = 10;
                return sender.setParameters(oldParam);

              case 10:
                this.logVideoTransceiverParameters();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setVideoSendingBitrateKbps",
    value: function setVideoSendingBitrateKbps(_bitrateKbps) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return");

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "setupLocalTransceivers",
    value: function setupLocalTransceivers() {
      if (!this.useTransceivers()) {
        return;
      }

      if (!this.defaultMediaStream && typeof MediaStream !== 'undefined') {
        this.defaultMediaStream = new MediaStream();
      }

      if (!this._localAudioTransceiver) {
        this._localAudioTransceiver = this.peer.addTransceiver('audio', {
          direction: 'inactive',
          streams: [this.defaultMediaStream]
        });
      }

      if (!this._localCameraTransceiver) {
        var encodingParams = Array.from(this.videoQualityControlParameterMap.values());
        this._localCameraTransceiver = this.peer.addTransceiver('video', {
          direction: 'inactive',
          streams: [this.defaultMediaStream],
          sendEncodings: encodingParams
        });
      }
    }
  }, {
    key: "logVideoTransceiverParameters",
    value: function logVideoTransceiverParameters() {
      var params = this._localCameraTransceiver.sender.getParameters();

      var encodings = params.encodings;
      var msg = 'simulcast: current encoding parameters \n';

      var _iterator = _createForOfIteratorHelper(encodings),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var encodingParam = _step.value;
          msg += "rid=".concat(encodingParam.rid, " maxBitrate=").concat(encodingParam.maxBitrate, " active=").concat(encodingParam.active, " scaleDownBy=").concat(encodingParam.scaleResolutionDownBy, " \n");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.logger.info(msg);
    }
  }], [{
    key: "replaceAudioTrackForSender",
    value: function replaceAudioTrackForSender(sender, track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (sender) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", false);

              case 2:
                _context3.next = 4;
                return sender.replaceTrack(track);

              case 4:
                return _context3.abrupt("return", true);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }]);

  return SimulcastTransceiverController;
}(DefaultTransceiverController_1.default);

exports.default = SimulcastTransceiverController;
SimulcastTransceiverController.LOW_LEVEL_NAME = 'low';
SimulcastTransceiverController.MID_LEVEL_NAME = 'mid';
SimulcastTransceiverController.HIGH_LEVEL_NAME = 'hi';
SimulcastTransceiverController.NAME_ARR_ASCENDING = ['low', 'mid', 'hi'];
SimulcastTransceiverController.BITRATE_ARR_ASCENDING = [200, 400, 1100];